<template>
<a class="scroll-to-top rounded" href="#page-top">
	<i class="fas fa-angle-up"></i>
</a>
</template>
<script>
import $ from 'jquery'
export default {
	props: [],
	data: function() {
		return {

		}
	},
	mounted() {
		$(document).on('scroll', function() {
			var scrollDistance = $(this).scrollTop();
			if (scrollDistance > 100) {
				$('.scroll-to-top').fadeIn();
			} else {
				$('.scroll-to-top').fadeOut();
			}
		});
	}
}
</script>
